import * as React from "react";

const MakeOfferArrowSVG = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
    <path
      fill="#F8FAFC"
      d="m22.832 26.673-1.07-1.044 4.88-4.88H10.494V19.25h16.156l-4.864-4.879 1.045-1.044L29.505 20z"
    ></path>
  </svg>
);

export default MakeOfferArrowSVG;
